import { useEffect, useState } from "react";
import i18next from "i18next";
import { useAtom } from "jotai";
import { userSettingsAtom } from "@/atoms/user-settings";
import { Language } from "@/config";

export const useI18n = () => {
  const [settings, setSettings] = useAtom(userSettingsAtom);
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    i18next.on("initialized", () => {
      setInitialized(true);
    });
    i18next.on("languageChanged", (lang) => {
      setSettings((prev) => {
        return { ...prev, language: lang as Language };
      });
    });

    return () => {
      i18next.off("initialized");
      i18next.off("languageChanged");
    };
  }, [setSettings]);

  return { initialized, language: settings.language };
};
